import { PatternA, PatternB, PatternC, PatternD, PatternE } from '../../constant/patterns';
import { DrawingPatternData } from '../../interface';

class Pattern {
  public static patterns: Array<DrawingPatternData> = [
    {
      pattern: 0, // ㅡ
      color: 0x77ddff,
      answers: PatternA,
      similarityPassLimit: 0.65,
      angleCounts: [0, 1],
    },
    {
      pattern: 1, // |
      color: 0x66cc88,
      answers: PatternB,
      similarityPassLimit: 0.65,
      angleCounts: [0, 1],
    },
    {
      pattern: 2, // V
      color: 0xdd66cc,
      answers: PatternC,
      similarityPassLimit: 0.5,
      angleCounts: [0, 1, 2, 3],
    },
    {
      pattern: 3, // ^
      color: 0xbbddff,
      answers: PatternD,
      similarityPassLimit: 0.5,
      angleCounts: [0, 1, 2, 3],
    },
    {
      pattern: 4, // O
      color: 0xff6666,
      answers: PatternE,
      similarityPassLimit: 0.6,
      angleCounts: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    },
  ];

  public static getAnglePatterns(angleCount: number): Array<DrawingPatternData> {
    return Pattern.patterns.filter((pattern) => pattern.angleCounts.includes(angleCount));
  }
}

export default Pattern;
